import React, { useState } from 'react';
import WritingsChart from './WritingsChart';

// Newest first. "Some Things I Believe In" (things.js) stays in the repo but is not listed.
const POSTS = [
    { date: '2026-05-20', title: 'Why FX Stablecoins Have Never Taken Off', href: 'https://x.com/nicoypei/status/2057125519389229272', src: 'X' },
    { date: '2026-02-03', title: "Why Institutions Aren't Coming On-Chain", href: 'https://x.com/nicoypei/status/2018739457399095799?s=20', src: 'X' },
    { date: '2026-01-07', title: 'Why Fixed-Rate Lending Never Took Off On-chain', href: 'https://x.com/nicoypei/status/2008941684860617213?s=20', src: 'X' },
    { date: '2024-10-21', title: 'Why Stripe acquired Bridge for 1.1 Billion', href: 'https://nicopeieth.substack.com/p/why-stripe-acquired-bridge-for-11b?r=15ka7e', src: 'Substack' },
    { date: '2024-10-09', title: 'What Stripe Has Done Wrong with Their Crypto Payment Solution', href: 'https://nicopeieth.substack.com/p/what-stripe-has-done-wrong-with-their?r=15ka7e', src: 'Substack' },
    { date: '2022-12-09', title: 'General-Purpose vs App-Specific Guide for Application Developers', href: 'https://nicopeieth.substack.com/p/general-purpose-vs-app-specific-guide?r=15ka7e', src: 'Substack' },
];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const fmt = (d) => { const [y, m] = d.split('-'); return `${MONTHS[+m - 1]} ${y}`; };

function WritingsContent() {
  const [active, setActive] = useState(null);
  return (
      <section id="writing" className="block">
          <div className="block-head">
              <h2>Writing</h2>
              <p>Market structure, rates, and where the money actually moves. Usually on X first.</p>
          </div>

          <WritingsChart posts={POSTS} active={active} setActive={setActive} />

          <ol className="posts">
              {POSTS.map((p, i) => (
                  <li key={p.href} className={active === i ? 'is-active' : ''} onMouseEnter={() => setActive(i)} onMouseLeave={() => setActive(null)}>
                      <a href={p.href} target="_blank" rel="noopener noreferrer" onFocus={() => setActive(i)} onBlur={() => setActive(null)}>
                          <span className="post-title">{p.title}</span>
                          <span className="post-meta">{p.src} · <time dateTime={p.date}>{fmt(p.date)}</time></span>
                      </a>
                  </li>
              ))}
          </ol>

          <p className="more">
              More on <a href="https://x.com/nicoypei" target="_blank" rel="noopener noreferrer">X</a> and <a href="https://nicopeieth.substack.com/" target="_blank" rel="noopener noreferrer">Substack</a>.
          </p>
      </section>
  );
}

export default WritingsContent;
